export const MuiCardContent = {
    MuiCardContent: {
        styleOverrides: {
            root: {
                padding: 24,
            },
        },
    },
};
